export const dotPositionStyles = {
  top: {
    top: '-8%',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  'top-right': {
    top: 0,
    right: '-8%',
  },
  right: {
    top: '50%',
    right: '-8%',
    transform: 'translateY(-50%)',
  },
  'bottom-right': {
    bottom: '-8%',
    right: '-8%',
  },
  bottom: {
    bottom: '-8%',
    left: '50%',
    transform: 'translateX(-50%)',
  },
  'bottom-left': {
    bottom: '-8%',
    left: '-8%',
  },
  left: {
    top: '50%',
    left: '-8%',
    transform: 'translateY(-50%)',
  },
  'top-left': {
    top: '-8%',
    left: '-8%',
  },
};
